import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'adc-color-picker',
  templateUrl: './adc-color-picker.component.html',
  styleUrls: ['./adc-color-picker.component.css'],
  standalone: false
})
export class AdcColorPickerComponent {
  @Input() colors: any;
  @Output() updatedColorArr: EventEmitter<any>;

  newColor: string = '#ffffff';
  isNewColorPickerVisible: boolean = false;

  constructor() {
    this.updatedColorArr = new EventEmitter<any>;
  }

  openColorPicker(index: number) {
    this.closeAllPickers(); // Close all other pickers

    if (index === -1) {
      this.isNewColorPickerVisible = true; // Open picker for new color
    } else {
      this.colors[index].isPickerVisible = true; // Open picker for specific color
    }
  }

  closeAllPickers() {
    this.colors.forEach((color: any) => color.isPickerVisible = false); // Close all color pickers
    this.isNewColorPickerVisible = false; // Close new color picker
  }

  addColor(index: number, type: string) {
    if (type === 'edit' && index !== -1) {
      this.colors[index].isPickerVisible = false; // Hide picker after editing
      this.updatedColorArr.emit(this.colors);
    } else if (type === 'new') {
      this.colors.push({ color: this.newColor, isPickerVisible: false });
      this.isNewColorPickerVisible = false; // Hide new color picker
      this.updatedColorArr.emit(this.colors);
    }
  }

  removeColor(index: number) {
    this.colors.splice(index, 1); // Remove the color block from the array
    this.updatedColorArr.emit(this.colors);
  }
}
